export const LIST_OF_DATABASES_REQUEST = "LIST_OF_DATABASES_REQUEST";
export const LIST_OF_DATABASES_SUCCESS = "LIST_OF_DATABASES_SUCCESS";
export const LIST_OF_DATABASES_FAILURE = "LIST_OF_DATABASES_FAILURE";
